export const GetDocumentLatest = (id) =>
  `/Document/GetDocumentLatest?TypeId=${id}`;

export const DocumentLatestConfirmed = "/Document/DocumentLatestConfirmed";
